import { styled } from "@mui/system";
import FormControlLabel from "@mui/material/FormControlLabel";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import {
  brandFontFamily,
  brandFontSize,
  brandInputTextColor,
  brandSecondaryColor,
} from "../../../utils/variables";

const CustomFormControlLabel = styled(FormControlLabel)(({ theme }) => ({
  "& .MuiFormControlLabel-label": {
    fontFamily: brandFontFamily,
    color: brandInputTextColor,
    fontSize: brandFontSize,
    fontWeight: 300,
    marginTop: "1px",
  },
}));

const CustomRadio = styled(Radio)(({ theme, color, fontSize }) => ({
  color: `${color ? color : brandSecondaryColor} !important`,
  "& .Mui-checked .MuiSvgIcon-root": {
    color: `${brandSecondaryColor} !important`,
  },

  "& .MuiSvgIcon-root": {
    fontSize: fontSize ? fontSize : "18px", // Change this value to adjust the size
  },
}));

const BaseRadio = ({
  label,
  checked,
  value,
  color,
  fontSize,
  defaultValue = "",
  ...props
}) => {
  return (
    <CustomFormControlLabel
      value={value}
      control={
        <CustomRadio
          checked={checked}
          {...props}
          color={color}
          fontSize={fontSize}
        />
      }
      label={label}
      {...props}
    />
  );
};

const CustomRadioGroup = styled(RadioGroup)(({ theme }) => ({
  fontFamily: brandFontFamily,
  color: brandInputTextColor,
  "& .MuiFormControlLabel-root": {
    marginBottom: "8px",
  },
}));

export default BaseRadio;
